export default __webpack_public_path__ + "static/media/Seera-Thumb-1.278d11d0.png";